export default __webpack_public_path__ + "static/media/gh.7c58c56e.svg";